<template>
  <v-app id="inspire" style="background: #f8f9fb">
    <v-main>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <app-header />
            <v-card class="auth-card mx-auto" max-width="460" elevation="0">
              <div class="auth-head">
                <h2 class="auth-title">Forgot password?</h2>
                <p class="auth-sub">
                  Enter your email and we'll send you a reset code
                </p>
              </div>
              <v-form v-model="valid">
                <v-text-field
                  id="email"
                  label="Email"
                  name="email"
                  prepend-inner-icon="mdi-email-outline"
                  type="email"
                  :rules="[required('email'), emailFormat()]"
                  v-model="email"
                  outlined
                  dense
                ></v-text-field>
                <v-btn
                  block
                  large
                  id="submit"
                  class="auth-btn mt-2"
                  :loading="loading"
                  :disabled="!valid"
                  @click="onReset"
                  >Reset Password</v-btn
                >

                <div class="tw-flex tw-justify-center tw-items-center mt-4">
                  <span class="grey--text body-2 mr-2"
                    >Already have an account?
                  </span>
                  <router-link to="/" class="auth-link">Login</router-link>
                </div>
              </v-form>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <app-bottom />
  </v-app>
</template>

<script>
import validation from '@/utils/Validations'
import { mapGetters } from 'vuex'
export default {
  components: {
    appHeader: () => import('@/components/Logo'),
    appBottom: () => import('@/components/BottomImage'),
  },
  props: {
    source: String,
  },
  data() {
    return {
      valid: false,
      email: '',
      loading: false,
      ...validation,
    }
  },
  computed: {
    ...mapGetters('auth', ['hasAuthenticationStatus', 'authenticationStatus']),
  },
  methods: {
    onReset() {
      this.loading = true

      this.$store
        .dispatch('auth/passwordReset', {
          username: this.email,
        })
        .then(() => {
          if (this.hasAuthenticationStatus) {
            this.loading = false
            if (this.authenticationStatus.variant === 'error') {
              this.$store.commit('SNACKBAR', this.authenticationStatus)
            } else {
              this.$store.commit('SNACKBAR', this.authenticationStatus)
              this.$router
                .push({
                  name: 'ResetPassword',
                  query: { user: this.email },
                })
                .catch(() => {})
            }
          }
        })
    },
  },
}
</script>

<style scoped>
.auth-card {
  border-radius: 18px;
  border: 1px solid #e8edf5;
  background: #ffffff;
  box-shadow: 0 18px 48px rgba(15, 42, 85, 0.12);
  padding: 28px 30px 30px;
}
.auth-head {
  text-align: center;
  margin-bottom: 18px;
}
.auth-title {
  font-size: 22px;
  font-weight: 800;
  color: #0f2a55;
  margin: 0;
}
.auth-sub {
  font-size: 13px;
  color: #6b7a90;
  margin-top: 4px;
}
.auth-link {
  color: #034ea2;
  font-weight: 600;
  font-size: 13px;
  text-decoration: none;
}
.auth-link:hover {
  text-decoration: underline;
}
.auth-btn {
  background: linear-gradient(135deg, #034ea2 0%, #0a63c4 100%) !important;
  color: #ffffff !important;
  border-radius: 10px;
  font-weight: 700;
  letter-spacing: 0.3px;
  box-shadow: 0 8px 20px rgba(3, 78, 162, 0.3);
}
.auth-btn.v-btn--disabled {
  background: #e6ebf3 !important;
  color: #4b5a70 !important;
  box-shadow: none;
}
/* Soft rounded inputs */
.auth-card ::v-deep .v-text-field--outlined .v-input__slot {
  border-radius: 10px;
}
.auth-card ::v-deep .v-text-field--outlined fieldset {
  border-color: #d6deea;
}
.auth-card ::v-deep .v-text-field--outlined.v-input--is-focused fieldset {
  border-color: #034ea2;
}
</style>
